import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { isLoadingSelector } from '../../registrationSlice.js';
import { useAppSelector } from '../../../../hooks/redux/index.js';
export const RegistrationButton = ({ onClick }) => {
    const { t } = useTranslation();
    const isLoadingState = useAppSelector(isLoadingSelector);
    return (_jsx(Button, { "data-testid": "register-submit-btn", autoFocus // it is used to focus on the button first instead of the input fields
        : true, variant: "primary", a11yLabel: "Log in button", type: "submit", onClick: onClick, isLoading: isLoadingState, isFullWidth: true, marginTop: 'spaceL', size: ['medium'], children: t('loginregistration.registration.button') }));
};
//# sourceMappingURL=RegistrationButton.js.map